import React from 'react';
import MarkSerializer, { type MarkSerializeArguments } from './MarkSerializer';

// Marks that are converted to HTML inline tags.
class SerializerInlineMarks extends MarkSerializer {
  static deserializeTagsToMarks = {
    strong: 'bold',
    b: 'bold',
    em: 'italic',
    i: 'italic',
    u: 'underline',
    ins: 'underline',
    s: 'strikethrough',
    del: 'strikethrough',
    strike: 'strikethrough',
  };

  static serializeMarks = {
    bold: ({ children, styles, otherProps }: MarkSerializeArguments) => (
      <strong style={styles} {...otherProps}>
        {children}
      </strong>
    ),
    italic: ({ children, styles, otherProps }: MarkSerializeArguments) => (
      <em style={styles} {...otherProps}>
        {children}
      </em>
    ),
    strikethrough: ({
      children,
      styles,
      otherProps,
    }: MarkSerializeArguments) => (
      <del style={styles} {...otherProps}>
        {children}
      </del>
    ),

    underline: ({ children, styles, otherProps }: MarkSerializeArguments) => (
      <u style={styles} {...otherProps}>
        {children}
      </u>
    ),
  };
}

export default SerializerInlineMarks;
